import React, { useContext, useState, useEffect } from 'react'
import AuthContext from '../../context/AuthContext'
import { InlineLoading, Breadcrumb, BreadcrumbItem, Tile, Form, FormGroup, TextInput, Button, InlineNotification, NotificationActionButton } from 'carbon-components-react'
import Toast from '../../components/Notification/Toast'
import { sleep } from '../../utils/functions/tools/sleep';
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
  NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;

const GeneralSettings = ({ match }) => {

  // Variables for modals and toasts
  const [error, setError] = useState(false);
  const [list, setList] = useState([]);
  let toastProperties = null;

  // Other Variables
  let { authTokens } = useContext(AuthContext)
  let [generalSettings, setGeneralSettings] = useState([])

  // Inline loading
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [description, setDescription] = useState('Sending...');
  const [ariaLive, setAriaLive] = useState('off');
  const [inlineLoadingState, setInlineLoadingState] = useState('');

  useEffect(() => {
    const getGeneral = async () => {
      let response = await fetch(`${API_URL}/system/settings/general/`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + authTokens?.access
        }
      })
      let data = await response.json()
      setGeneralSettings(data)
    }
    getGeneral()
    document.title = "General Settings | WillowBMS"
  }, [])

  const showToast = (type, title, description) => {
    const id = Math.floor((Math.random() * 100) + 1);
    const time = new Date().toLocaleString();

    switch (type) {
        case 'success':
            toastProperties = {
                id,
                title: title,
                description: description,
                kind: 'success',
                time: time
            }
            break;
        case 'error':
            toastProperties = {
                id,
                title: title,
                description: description,
                kind: 'error',
                time: time
            }
            break;
        case 'info':
            toastProperties = {
                id,
                title: title,
                description: description,
                kind: 'info',
                time: time
            }
            break;
        case 'warning':
            toastProperties = {
                id,
                title: title,
                description: description,
                kind: 'warning',
                time: time
            }
            break;
        default:
            setList([]);
    }
    setList([...list, toastProperties]);
  }

  let updateGeneral = async (values) => {
    values.preventDefault();
    let response = await fetch(`${API_URL}/system/settings/general/`, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authTokens?.access
      },
      body: JSON.stringify({
        'id': 1,
        'name': values.target.siteName.value,
        'domain': values.target.domainName.value,
        'pubDomain': values.target.publicName.value
      })
    })
    if (response.status === 200) {
      setError(false)
      showToast("success", "Success", "System general settings have been saved.")

      setIsSubmitting(false);
      setSuccess(true);
      setDescription('Saved!');
      setInlineLoadingState("finished")
      await sleep(2000)
      setSuccess(false);
      setDescription('Saving...');
      setAriaLive('off');
      setInlineLoadingState("")
    } else {
      setError(true)

      setIsSubmitting(false);
      setSuccess(true);
      setDescription('Something went wrong.');
      setInlineLoadingState("error")
      await sleep(2000)
      setSuccess(false);
      setDescription('Saving...');
      setAriaLive('off');
      setInlineLoadingState("")
    }
  }

  return (
    <div id="body" className="bms-page d-flex">
      <Toast toastList={list} />
      <div className="wrapper">
        <Breadcrumb>
          <BreadcrumbItem href="/system/settings/general">Settings</BreadcrumbItem>
          <span>General</span>
        </Breadcrumb>
        <h2>
          Settings
        </h2>
        <Tile light={true} className="row mt-1">
          <h5 className="tile-title">General</h5>
          {error && <InlineNotification kind="error" hideCloseButton={true} title="Error: Unable to save general system settings" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
          <Form onSubmit={updateGeneral}>
            <FormGroup className="d-flex flex-w">
              <div className="col-12 col-md-6 m-005">
                <TextInput
                  id="siteName"
                  invalidText="Site name is required"
                  labelText="Site Name"
                  placeholder="Enter the site name"
                  defaultValue={generalSettings?.name}
                  required
                />
              </div>
              <div className="col-12 col-md-6 m-005">
                <TextInput
                  id="domainName"
                  invalidText="API domain name is required"
                  labelText="API Domain Name"
                  placeholder="Enter the API domain name"
                  defaultValue={generalSettings?.domain}
                  required
                />
              </div>
              <div className="col-12 col-md-6 m-005">
                <TextInput
                  id="publicName"
                  invalidText="Public domain name is required"
                  labelText="Public Domian Name"
                  placeholder="Enter the public domain name"
                  defaultValue={generalSettings?.pubDomain}
                  required
                />
              </div>
              <div className="col-12 m-005">
              {isSubmitting || success ? (
                  <InlineLoading
                    style={{ marginLeft: '1rem' }}
                    description={description}
                    status={success ? inlineLoadingState : 'active'}
                    aria-live={ariaLive}
                  />
                ) : (
                  <Button type="submit">Save Changes</Button>
                )}
              </div>
            </FormGroup>
          </Form>
        </Tile>
      </div>
    </div>
  )
}

export default GeneralSettings